import * as Yup from 'yup';


const PrioritiesSchema=Yup.object().shape({
	priorities: Yup.array().min(5, "Please select minimum of 5 priorities").max(5,'Please select exactly 5 priorities')
});

export default PrioritiesSchema;
